import StaffContactDetails from 'app/shared-components/StaffContactDetails';
import { useParams } from 'react-router-dom';

const StaffDetails = () => {
  const { id } = useParams();
  return <StaffContactDetails id={id} />;
};

export default StaffDetails;
